// extracted by mini-css-extract-plugin
export default {"mainWrapper":"QRCodeGenerator_mainWrapper__HFHVo","qrcodeWrapper":"QRCodeGenerator_qrcodeWrapper__SZgPc","downloadBtn":"QRCodeGenerator_downloadBtn__B96bG"};